var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortDesc = function SvgSortDesc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.2 4.8v10.8h2.7l-3.6 4.5-3.6-4.5h2.7V4.8zM12 17.4v1.8H3.9v-1.8zm1.8-6.3v1.8H3.9v-1.8zm0-6.3v1.8H3.9V4.8z"
  })));
};
export default SvgSortDesc;